<template>
	<div class="calculator__nav">
		<div class="calculator__nav-inner">
			<button
				v-if="showReset"
				type="button"
				class="mdc-button calculator__nav-reset"
				:data-event="resetEventId"
				@click="$store.commit('reset')"
			>
				{{ $store.state.i18n.reset }}
			</button>

			<button
				v-if="onReturn"
				type="button"
				class="mdc-button mdc-button--outlined calculator__nav-prev"
				:data-event="returnEventId"
				@click="onReturn"
			>
				<span class="material-icons">navigate_before</span>
				{{ returnLabel }}
			</button>

			<button
				v-if="onContinue"
				type="button"
				class="mdc-button mdc-button--raised calculator__nav-next"
				:data-event="continueEventId"
				@click="onContinue"
			>
				{{ continueLabel }}
				<span class="material-icons">navigate_next</span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Navigation',
	props: {
		resetEventId: {
			type: String,
			default: 'reset'
		},
		returnLabel: String,
		onReturn: Function,
		returnEventId: {
			type: String,
			default: 'return'
		},
		continueLabel: String,
		onContinue: Function,
		continueEventId: {
			type: String,
			default: 'continue'
		}
	},
	computed: {
		showReset() {
			const showReset = this.$store.state.resetEnabled && this.$store.state.isResettable;

			return showReset;
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__nav {
	margin-top: 80px;
}

.calculator__nav-inner {
	display: flex;
	justify-content: space-between;
}

.calculator__nav-next {
	margin-left: auto;
}

.calculator__nav-reset {
	margin-right: auto;
}

/* Desktop */
@media (min-width: 64rem) {
	.calculator__nav {
		display: flex;
		margin-left: calc(-1 * var(--spacing));
		margin-right: calc(-1 * var(--spacing));
	}

	.calculator__nav-inner {
		flex-basis: 66.667%;
		padding: 0 var(--spacing);
		box-sizing: border-box;
	}
}
</style>
